var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.82422C16 10.9459 15.1571 12.9808 13.6569 14.4811C12.1566 15.9813 10.1217 16.8242 8 16.8242C5.87827 16.8242 3.84344 15.9813 2.34315 14.4811C0.842855 12.9808 0 10.9459 0 8.82422C0 6.70249 0.842855 4.66766 2.34315 3.16737C3.84344 1.66707 5.87827 0.824219 8 0.824219C10.1217 0.824219 12.1566 1.66707 13.6569 3.16737C15.1571 4.66766 16 6.70249 16 8.82422Z",
    fill: "url(#paint0_linear_2_1665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.83222C3 10.8472 4.006 14.8242 8 14.8242C11.993 14.8242 13 10.8472 13 8.83222C13 8.67322 11.39 7.82422 8 7.82422C4.61 7.82422 3 8.67322 3 8.83222Z",
    fill: "url(#paint1_linear_2_1665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54102 13.3242C5.34502 14.3192 6.44802 14.8242 8.01002 14.8242C9.57302 14.8242 10.665 14.3192 11.469 13.3242C10.918 12.7362 9.87002 11.8242 8.01002 11.8242C6.15002 11.8242 5.09302 12.7362 4.54102 13.3242Z",
    fill: "url(#paint2_linear_2_1665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21297 4.968C6.47597 5.156 6.71497 5.423 6.62297 5.756C6.55197 6.01 6.42897 6.125 6.20097 6.127C5.42097 6.138 4.49297 6.382 3.69497 6.739C3.62997 6.768 3.49797 6.827 3.36297 6.824C3.23897 6.821 3.11197 6.766 3.03597 6.587C2.96897 6.43 2.96297 6.199 3.31197 5.989C3.85697 5.659 4.56897 5.509 5.22097 5.385C4.81154 5.08245 4.37065 4.82496 3.90597 4.617C3.47897 4.423 3.52597 4.16 3.58297 4.017C3.70997 3.7 4.19197 3.821 4.66097 4.043C5.20802 4.2985 5.72797 4.60839 6.21297 4.968ZM9.78997 4.968C10.2742 4.60824 10.7935 4.29833 11.34 4.043C11.81 3.821 12.29 3.7 12.418 4.017C12.475 4.16 12.522 4.423 12.095 4.617C11.6308 4.82475 11.1906 5.08226 10.782 5.385C11.432 5.508 12.145 5.659 12.689 5.989C13.038 6.199 13.031 6.429 12.965 6.587C12.888 6.767 12.762 6.821 12.638 6.824C12.503 6.827 12.371 6.768 12.306 6.739C11.509 6.382 10.581 6.139 9.80197 6.127C9.57397 6.125 9.45097 6.01 9.37997 5.757C9.28897 5.424 9.52697 5.157 9.78997 4.969V4.968Z",
    fill: "#2A3755"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1665",
    x1: 8,
    y1: 2.46422,
    x2: 8,
    y2: 16.8242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1665",
    x1: 8,
    y1: 7.82422,
    x2: 8,
    y2: 14.8242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#472315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B3A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1665",
    x1: 8.005,
    y1: 11.8242,
    x2: 8.005,
    y2: 14.2812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC607C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91F3A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.824219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaha);
export default __webpack_public_path__ + "static/media/haha.6d49c73d24aba99e47ba7950a2491f32.svg";
export { ForwardRef as ReactComponent };